import { render, staticRenderFns } from "./SingleHistorialAccordion.vue?vue&type=template&id=15554589&scoped=true&"
import script from "./SingleHistorialAccordion.vue?vue&type=script&lang=js&"
export * from "./SingleHistorialAccordion.vue?vue&type=script&lang=js&"
import style0 from "./SingleHistorialAccordion.vue?vue&type=style&index=0&id=15554589&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15554589",
  null
  
)

export default component.exports